module.exports = __webpack_public_path__ + "img/new_report1.353cab45.png";